// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templates-container{gap:1.5rem;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/views/Templates/GivingFormTemplates.scss"],"names":[],"mappings":"AAAA,qBACE,UAAA,CACA,sBAAA","sourcesContent":[".templates-container {\n  gap: 1.5rem;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
